import React, { useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import  FormulaBuilder from '../CalculatedSensor/FormulaBuilder';
import * as classes from './CustomCalculationPanel.module.css';

const CustomCalculationPanel = ({
    sensorId,
    sensorCalculations,
    sensors,
    sensorTypes,
    selectedCalculation,
    selectedSensor,
    setSelectedCalculation,
    setCalculation,
    setSensorSelection,
    setIsValidFormula,
    setExternalEquipment,
    setExternalSensors,
    externalSensors,
    ...props
}) => {

    useEffect(() => {
        if (!selectedCalculation) return;

    }, [selectedCalculation]);

    const syncTitle = (val) => {
        //text.current = val;
        //formik.setFieldValue('name', val, false);
    };

    const filterSensorTypes = sensorTypeIds =>{
        //  let filteredSensor = sensorTypes[0].items.filter(c=>sensorTypeIds.has(c.id));
        //  setFilteredSensorTypes([{items: Array.from(filteredSensor)}]);
    };

    const filterSensorTypesRaw = sensorTypeIds =>{
        //  let filteredSensor = sensorTypes.filter(c=>sensorTypeIds.has(c.id));
        // setFilteredSensorTypes([{items: Array.from(filteredSensor)}]);
    };

    return (
        <div className={classes.CalculationPanel}>
            <div className={classes.TabPanel}>
                <Tabs
                    value={0}
                    classes={{
                        root:      classes.Root,
                        indicator: classes.Indicator
                    }}
                    textColor="inherit"
                    aria-label="disabled tabs example"
                >
                    <Tab
                        classes={{
                            root:     classes.Tab,
                            selected: classes.ActiveTab
                        }}
                        label="Formula Builder"
                        disableRipple
                    />
                </Tabs>
            </div>
            <div className={classes.BodyPanel} >
                <FormulaBuilder
                    mode={'sensor'} syncTitle={syncTitle} filterSensorTypes={filterSensorTypes}
                    selectedTemplate={selectedCalculation}
                    selectedCalculation={selectedSensor}
                    filterSensorTypesRaw={filterSensorTypesRaw} setExternalEquipment={setExternalEquipment}
                    setIsValidFormula={setIsValidFormula}
                    isCustom={true}
                    setExternalSensors={setExternalSensors}
                    externalSensors={externalSensors}
                />
            </div>
        </div>
    );
};

export default CustomCalculationPanel;
